import apiInstance from "../../config/api";

export async function getNaray8ByCategory(payload, pagination) {
    const { slug, status, filter } = payload
    const params = {
        page: pagination.page || 1,
        limit: pagination.limit || 10,
        ...(slug === "search" ? {} : { filter: filter || "hot" }),  // hot, random, latest
        ...(slug === "search" ? { searchQuery: filter } : {})  // hot, random, latest
    }
    let res;
    if (slug === "trending") {
        res = await apiInstance.get("/api/narrate/trending-popular", { params })
    }
    else if (slug === "recommended") {
        res = await apiInstance.get("/api/narrate/recommendations/stories", { params })
    }
    else if (slug === "completed") {
        res = await apiInstance.get("/api/narrate/stories/completed", { params })
    } else if (slug === "search") {
        res = await apiInstance.get("/api/narrate/search", { params })
    }
    else {
        res = await apiInstance.post(`/api/narrate/stories/search`, { category: slug, contentStatus: status }, { params })
    }

    return res.data
}

export async function createNaray8Story(payload) {
    const formData = new FormData();

    formData.append("title", payload.title);
    formData.append("description", payload.description);
    formData.append("genre", payload.genre);
    formData.append("category", payload.category);

    payload.tags?.forEach(tag =>
        formData.append("tags[]", tag)
    );

    payload.mainCharacters?.forEach(char =>
        formData.append("mainCharacters[]", char)
    );

    if (payload.explicitLanguage !== undefined) {
        formData.append("explicitLanguage", String(payload.explicitLanguage));
    }

    if (payload.violentThemes !== undefined) {
        formData.append("violentThemes", String(payload.violentThemes));
    }

    if (payload.adultContent !== undefined) {
        formData.append("adultContent", String(payload.adultContent));
    }

    if (payload.coverImage) {
        formData.append("coverImage", payload.coverImage);
    }

    const response = await apiInstance.post(`/api/narrate`, formData)
    return response.data.data
}

export async function deleteNaray8Story(narrateId) {
    const response = await apiInstance.delete(`/api/narrate/${narrateId}`)
    return response.data
}

export async function updateNaray8Story(id, payload) {
    const formData = new FormData();
    for (const key in payload) {
        if (payload[key] !== undefined) {
            if (Array.isArray(payload[key])) {
                payload[key].forEach(item => formData.append(`${key}[]`, item));
            } else {
                formData.append(key, payload[key]);
            }
        }
    }
    const response = await apiInstance.put(`/api/narrate/${id}`, formData)
    return response.data.data
}

export async function getNaray8Owner(id) {
    const response = await apiInstance.post("/api/narrate/owner/story", { narrateId: id })
    return response.data.data
}

export async function getAllNaray8ChaptersOwner(narrayId) {
    const response = await apiInstance.post("/api/narrate/owner/chapters", { narrateId: narrayId })
    return response.data.data
}

export async function getNaray8Story(id) {
    const response = await apiInstance.get(`/api/narrate/${id}`)
    return response.data.data
}

export async function getAllNaray8Chapters(narrayId) {
    const response = await apiInstance.get(`/api/narrate/${narrayId}/chapters`)
    return response.data.data
}

export async function getNaray8Chapter(chapterId) {
    const response = await apiInstance.get(`/api/narrate/chapters/${chapterId}`)
    return response.data.data
}

export async function createNaray8Chapter(payload) {
    const response = await apiInstance.post(`/api/narrate/chapters`, payload)
    return response.data.data
}

export async function updateNaray8Chapter(payload) {
    const response = await apiInstance.put(`/api/narrate/chapters/${payload.chapterId}`, payload)
    return response.data.data
}

export async function setChaptersPrice(payload) {
    const response = await apiInstance.patch("/api/narrate/chapters/bulk-price", payload)
    return response.data
}

export async function purchaseNaray8Chapters(payload) {
    const response = await apiInstance.post("/api/narrate/chapters/purchase", payload)
    console.log("purchaseNaray8Chapters response: ", response.data)
    return response.data
}

export async function deleteNaray8Chapter(chapterId) {
    const response = await apiInstance.delete(`/api/narrate/chapters/${chapterId}`)
    return response.data.data
}

export const getNaray8Writer = async (writerId, isMine) => {
    let res
    if (isMine) {
        res = await apiInstance.get(`/api/narrate/author/personal`);
    } else {
        res = await apiInstance.get(`/api/narrate/author/${writerId}`);
    }
    return res.data.data;
};

export const getNaray8WriterFollowers = async (writerId, pagination) => {
    const params = {
        page: pagination.page || 1,
        limit: pagination.limit || 20
    }
    const res = await apiInstance.get(`/api/narrate/author/${writerId}/followers`, { params });
    return res.data;
};

export const addToNaray8Library = async (narrateId) => {
    const res = await apiInstance.post(`/api/library`, { narrateId })
    return res.data.status === "success"
}

export const removeFromNaray8Library = async (narrateId) => {
    const res = await apiInstance.delete(`/api/library/${narrateId}`)
    return res.data.status === "success"
}

export const getMyNaray8Library = async (pagination) => {
    const params = {
        page: pagination.page || 1,
        limit: pagination.limit || 20
    }
    const res = await apiInstance.get("/api/library", { params })
    return res.data
}

export const rateNaray8 = async (narrateId, rating) => {
    const res = await apiInstance.post(`/api/narrate/${narrateId}/rate`, { rating })
    return res.data
}

export const getNaray8WriterFollowing = async (pagination) => {
    const params = {
        page: pagination.page || 1,
        limit: pagination.limit || 20
    }
    const res = await apiInstance.get(`/api/narrate/author/following`, { params });
    return res.data;
};

export const toggleFollowWriter = async (writerId) => {
    const res = await apiInstance.post(`/api/narrate/author/${writerId}/follow`)
    return res.data.data.followed
}

export const checkFollowStatus = async (writerId) => {
    try {
        const following = await getNaray8WriterFollowing({ page: 1, limit: 100 });
        return following.data.some(follow => follow.userId === writerId);
    } catch (error) {
        console.error("Error checking follow status:", error);
        return false;
    }
}

export const updateWriterBio = async (authorAbout) => {
    const res = await apiInstance.put("/api/narrate/author/about", { authorAbout })
    return res.data.status === "success"
}

export const postNarray8Comment = async (payload) => {
    const response = await apiInstance.post("/api/narrate/comments", payload)
    return response.data
}

export const toggleLikeNarray8Comment = async (commentId) => {
    const response = await apiInstance.post(`/api/narrate/comments/${commentId}/like`)
    return response.data.data?.liked
}

export const deleteNarray8Comment = async (commentId) => {
    const response = await apiInstance.delete(`/api/narrate/comments/${commentId}`)
    return response.data.status === "success"
}

export const getNarray8Comment = async ({ narrateId, chapterId, page, limit }) => {
    const params = {
        page: page || 1,
        limit: limit || 10
    }

    let response;
    if (chapterId) {
        response = await apiInstance.get(`/api/narrate/comments/chapter/${chapterId}`, { params })
    } else {
       response = await apiInstance.get(`/api/narrate/comments/narrate/${narrateId}`, { params })
    }
    return response.data
}

export const getNarray8CommentReplies = async (commentId) => {
    const response = await apiInstance.get(`/api/comments/${commentId}`)
    return response.data
}

// ✅ NEW FUNCTION: Update story status (draft/published)
export const updateStoryStatus = async (narrateId, status) => {
    const response = await apiInstance.patch(`/api/narrate/${narrateId}/status`, { status });
    return response.data;
};